var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNabox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200.17 228.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2ac98b;fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nabox") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 64.12 0 170.46 30.79 188.21 30.79 112.14 61.47 129.86 61.47 205.88 92.27 223.63 92.27 117.28 0 64.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.94,54.39l30.85-18.08,38.33,22.43-30.83,18ZM100.83,0l-93,54.41,100.29,58.8,0,115.11,30.42-17.72V94.15l30.74-18V192.5l30.87-18.17V58.11Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNabox);
export default __webpack_public_path__ + "static/media/nabox.593c775ed54f40f52030513bacb86927.svg";
export { ForwardRef as ReactComponent };